<template>
  <aside id="side-menu">
    <sidebar-menu
      :menu="menu"
      :collapsed="false"
      :hide-toggle="true"
      @update:collapsed="onToggleCollapse"
      @item-click="onItemClick"
      width="200px"
    >
      <span slot="toggle-icon"
        ><font-awesome-icon
          style="cursor: pointer"
          icon="arrows-alt-h"
          fixed-width
        />
      </span>
      <span slot="dropdown-icon">
        <font-awesome-icon
          icon="fa fa-angle-right"
          style="cursor: pointer"
          fixed-width
        />
      </span>
    </sidebar-menu>
  </aside>
</template>

<script>
const logHeader = {
  data() {
    return { src: require("@/assets/img/logo_negativo.png") };
  },
  template: ` <div class="menu-header">
        <img
          class="site-logo"
          :src='src'
          alt="Logo Proeduca negativo"
        />
      </div>`,
};
export default {
  name: "AdminSidebar",
  props: {
    collapsed: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      menu: [
        {
          header: true,
          component: logHeader,
          hiddenOnCollapse: true,
        },
        {
          href: "/admin/licences",
          title: "Licencias LTI",
          icon: "fa fa-plug",
        },
        {
          title: "Cerrar sesión",
          icon: "fa fa-power-off",
        },
      ],
    };
  },
  methods: {
    onToggleCollapse(collapsed) {
      this.$emit("toggleCollapse", collapsed);
    },
    // eslint-disable-next-line no-unused-vars
    onItemClick(event, item, node) {
      if (item.icon === "fa fa-power-off") {
        window.$cookies.remove("LTI_JWT");
        this.$router.push({ name: "LoginAdmin" });
      }
    },
  },
};
</script>
